<template>
  <div class="footer">
    <div class="info">
      <div>
        <h2>{{ getFooterData.firstRow }}</h2>
        <p>{{ getFooterData.secondRow }}</p>
      </div>
      <!-- <div v-else>
        <h2>{{ getFooterData.firstRow_en }}</h2>
        <p>{{ getFooterData.secondRow_en }}</p>
      </div> -->
    </div>
    <div class="footer-nav">
      <nav>
        <ul>
          <li v-for="(menu,i) in menu" :key="i">
            <router-link v-if="!menu.isHidden" :to="menu.url" id="biga" :class="{ choice: menu.hasDropDown }">{{ menu.name }}
            </router-link>
            <ul v-if="!menu.isHidden">
              <li v-for="(subMenu,subIndex) in subMenu(menu.id)" :key="subIndex">
                <router-link v-if="!subMenu.isHidden" :to="subMenu.url">{{ subMenu.name }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    getFooterData () {
      return this.$store.getters['footer/finalFooter']
    },
    menu () {
      return this.$store.getters['navbar/finalMenu']
    }
  },
  methods: {
    subMenu (id) {
      return this.$store.getters['navbar/finalSubMenusFooter'](id)
    }
  }
}
</script>

<style scoped>
  .footer {
    margin-top: 50px;
    width: 100%;
    min-height: 515px;
    /* background: #0d6ca9; */
    background: #006884;
  }

  .footer .info {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .footer h2 {
    color: #F9BA10;
    text-transform: uppercase;
    margin: 15px 0px;
    font-weight: 700;
    font-size: 20px;
  }

  .footer p {
    color: white;
    font-size: 16px;
  }

  /* NAV */
  .footer-nav {
    margin-top: 20px;
    padding: 0px 170px;
  }

  nav {
    display: flex;
    justify-content: center;
    border-top: 2px solid #fff;
  }

  nav ul {
    position: relative;
  }

  nav ul li {
    position: relative;
    list-style: none;
    float: left;
  }

   nav ul li a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 16px 14px 7px 14px;
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    /* transition: all 0.3s ease; */
    text-transform: uppercase;
    pointer-events: none;
    cursor: default;
  }

  nav ul li ul {
    position: absolute;
    left: 0;
    width: 100%;
    display: block;
  }

  nav ul li ul a {
    color: white;
    transition: all 0.3s ease;
    font-size: 12px;
    font-weight: 400;
    text-transform: none;
    padding: 10px;
    padding-left: 15px;
    pointer-events: all;
    cursor: pointer;
  }

  nav ul li ul li a:hover {
    color: #edc00c;
  }

  nav ul li ul li {
    position: relative;
    width: 100%;
    min-height: 52px;
  }

  /* nav ul li ul li a{
    border: 1px solid rgba(0,0,0,0.2);
  } */

  nav a.router-link-active {
    color: #DBA30D;
  }

  @media (max-width: 1525px) {
    nav ul li a {
      font-size: 14px;
      padding: 16px 7px 7px 7px;
    }
  }

   @media (max-width: 1356px) {
    .footer-nav {
      padding: 0px 100px;
    }
   }

   @media (max-width: 1225px) {
    .footer {
      min-height: 0%;
      padding-bottom: 30px;
    }

    .footer-nav {
      display: none;
    }
  }

   @media (max-width: 1135px) {
    .footer h2 {
      margin: 15px 10px;
    }

    .footer p {
      margin: 0 5px;
    }
   }

   @media (max-width: 1080px) {
    .footer-nav {
      padding: 0px 50px;
    }
   }

   @media (max-width: 720px) {
    .footer-nav {
      padding: 0px 20px;
    }

    .footer {
      padding-bottom: 20px;
    }
   }
</style>
